import { Typography, Grid, Card, CardContent } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  stretch: { height: "100%" },
  item: { display: "flex", flexDirection: "column" }, // KEY CHANGES
}));

export const Sections = () => {
  return (
    <Grid container spacing={2} justify="space-between" alignItems="stretch">
      <Item
        xl={2}
        lg={2}
        md={6}
        xs={12}
        title="Big Title 1"
        content="Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!Lots and lots and lots and lots and lots and lots of content!"
      />
      <Item
        xl={4}
        lg={4}
        md={6}
        xs={12}
        title="Big Title 2"
        content="Not much content"
      />
      <Item
        xl={3}
        lg={3}
        md={6}
        xs={12}
        title="Big Title 3"
        content="Not much content"
      />
      <Item
        xl={3}
        lg={3}
        md={6}
        xs={12}
        title="Big Title 4"
        content="Not much content"
      />
    </Grid>
  );
};

const Item = ({ title, content, ...rest }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.item} item {...rest}>
      <Typography>{title}</Typography>
      <Card className={classes.stretch}>
        <CardContent>{content}</CardContent>
      </Card>
    </Grid>
  );
};
// <Typography>
//   This is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   This is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis
//   isThis is textThis is textThis is textThis is textThis is textThis is
//   textThi textThis is textThis is textThis is textThis is textThis is
//   textThis isThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis i textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis isThis is textThis is
//   textThis is textThis is textThis is textThis is textThis is textThis is
//   textThis is textThis is textThis is textThis is
// </Typography>

export default Sections;
